import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { variants } from '@circlefin/money';
import { MoneyInputCore } from './MoneyInput.Core/MoneyInput.Core.es.js';
import { MoneyInputCustom } from './MoneyInput.Custom/MoneyInput.Custom.es.js';

const MoneyInput = /*#__PURE__*/ forwardRef(({ currencyVariant = 'USD', ...props }, ref)=>jsx(MoneyInputCore, {
        ...props,
        ref: ref,
        currencyConfig: variants[currencyVariant]
    }));
MoneyInput.displayName = 'MoneyInput';
MoneyInput.Custom = MoneyInputCustom;

export { MoneyInput, MoneyInput as default };
//# sourceMappingURL=MoneyInput.es.js.map
